import type { MenuButton } from './types';

import { middot } from 'lib/html-entities';

export const menuButton: MenuButton = {
  id: null,
  title: `${ middot }${ middot }${ middot }`,
  component: null,
};
